import { render, staticRenderFns } from "./dictTypeAdd.vue?vue&type=template&id=d15d6caa&scoped=true&"
import script from "./dictTypeAdd.vue?vue&type=script&lang=ts&"
export * from "./dictTypeAdd.vue?vue&type=script&lang=ts&"
import style0 from "./dictTypeAdd.vue?vue&type=style&index=0&id=d15d6caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15d6caa",
  null
  
)

export default component.exports